import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTableStyle0 = gravityIconIndividualCss;

const GravityIconTable = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'a47aed5383384bd08bb87da94132efec2b698b9e', color: this.color, size: this.size }, h("svg", { key: '6bafd7fc9da7408c131e5ada1c152bce677c5f63', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '807980a185585a22e68312a77f10cc52a8b27fa5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 5.5v2.75H8V5.5H5.5Zm0 7V9.75H8v2.75H5.5Zm0 1.5v2.5H8V14H5.5Zm4 0v2.5h3V14h-3Zm4.5 0v2.5h2.5V14H14Zm2.5-1.5H14V9.75h2.5v2.75Zm-4 0h-3V9.75h3v2.75ZM14 8.25h2.5V5.5H14v2.75Zm-4.5 0h3V5.5h-3v2.75ZM4.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-13Z", fill: "currentColor" }))));
    }
};
GravityIconTable.style = GravityIconTableStyle0;

export { GravityIconTable as gravity_icon_table };

//# sourceMappingURL=gravity-icon-table.entry.js.map